// Amateur squads rarely have positions configured, and last name alone is hard
// to recognise — so the bench shows and sorts by full name (first then last).
export const fullName = (player) => `${player.firstName} ${player.lastName}`.trim();
export const sortByName = (players) => [...players].sort((a, b) => {
    const byFirst = a.firstName.localeCompare(b.firstName);
    if (byFirst !== 0)
        return byFirst;
    return a.lastName.localeCompare(b.lastName);
});
